module.exports = __webpack_public_path__ + "static/media/iphone_14_blue_plus.929b81cf.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_blue_plus.jpeg
// module id = 2122
// module chunks = 0